"use client";
import React, { useEffect, useRef, useState, useContext } from "react";
import { Button, Popover, Tag, Modal } from "antd";
import { debounce } from "lodash";
import Header from "@/components/Header";
import ScrollLazyLoadImage from "@/components/ScrollLazyLoadImage";
import LOGO from "@/assets/images/logo.png";
// import VIDEO_IMG from'./video_img.jpg'
import { usePostHog } from 'posthog-js/react';
import DownLoad from './Download'
import { detectDevice } from '@/utils'
import { Dialog } from 'antd-mobile'
import { DataContext } from '@/context';
import { RenderFooter } from "./RenderFooter"
import { recordClickType } from "@/apis/record";
import { clickTypeMapper } from '@/config/constent';
import { recordEventRecord } from '@/apis/record';
import ActivityImg from "@/assets/new_year_activity/活动弹窗@2x.png";
import "../App.scss";
import { table } from "console";
import { useActivityConfig } from "@/hooks/useActivityConfig";
import { useNavigate } from "react-router-dom";

const VIDEO_IMG = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/4.jpg'
// export const showAlert = (message: string) => {
//   eventBus.emit('alert-message-error', message)
// }
interface Props {
  userOtherInfo: any;
  payCountObj: any;
}

const Home: React.FC<Props> = (props: Props) => {
  const { mac_plugin_latest_url, win_plugin_latest_url } = useContext(DataContext);
  const posthog = usePostHog();
  const isPc = detectDevice()
  const { activityConfig } = useActivityConfig()
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [showBenefitModal, setShowBenefitModal] = useState(false);
  // const MAC_DOWNLOAD =
  // "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28MacOS%29.zip";
  // const WIN_DOWNLOAD =
  //   "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28Windows%29.zip";
  const TEACH_URL =
    "https://mi8elatzm1x.feishu.cn/wiki/SfaxwB67JiEoHAkvpf1cVUfInVf?from=from_copylink";
  const macRef = useRef<HTMLAnchorElement | null>(null);
  const winRef = useRef<HTMLAnchorElement | null>(null);

  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);
  const source = searchParams.get('s'); // source 参数值
  const detail = searchParams.get('d'); // detail 参数值
  // console.log('source, detail', source, detail);
  const xiaohongshu_link = 'https://www.xiaohongshu.com/user/profile/63070886000000000f005dba';
  const bilibili_link = 'https://space.bilibili.com/3546687805065289'
  const douyin_link = 'https://v.douyin.com/JZSjiobaTis/%201@2.com'

  const handleMACDownload = debounce(() => {
    if (!isPc) {
      Dialog.alert({
        content: '请在电脑端打开！',
        onConfirm: () => {
          console.log('Confirmed')
        },
      })
      return
    }
    if (macRef.current) {
      macRef.current?.click();
      if (source && detail) {
        // posthog?.capture('haohui_source_download', {
        //   source: source,
        //   detail: detail,
        //   type: 'mac'
        // });
        recordEventRecord({
          event_name: 'haohui_source_download',
          source: source,
          event_id: detail,
          tag: {
            type: 'mac',
          }
        })
      }
      recordEventRecord({
        event_name: 'haohui_download',
        tag: {
          type: 'mac',
        }
      })
      // posthog?.capture('haohui_download', {
      //   type: 'mac',
      //   info: navigator?.userAgent
      // });
    }
  }, 1000);

  const handleWINDownload = debounce(() => {
    if (!isPc) {
      Dialog.alert({
        content: '请在电脑端打开！',
        onConfirm: () => {
          console.log('Confirmed')
        },
      })
      return
    }
    if (winRef.current) {
      winRef.current?.click();
      if (source && detail) {
        // posthog?.capture('haohui_source_download', {
        //   source: source,
        //   detail: detail,
        //   type: 'win'
        // });
        recordEventRecord({
          event_name: 'haohui_source_download',
          source: source,
          event_id: detail,
          tag: {
            type: 'win',
          }
        })
      }
      recordEventRecord({
        event_name: 'haohui_download',
        tag: {
          type: 'win',
        }
      })
      // posthog?.capture('haohui_download', {
      //   type: 'win',
      //   info: navigator?.userAgent
      // });

    }
  }, 1000);

  const handleTeach = () => {
    window.open(TEACH_URL);
  };
  const handleJumpLink = () => {
    searchParams.delete('y');
    navigate({
      pathname: '/price', 
      search: '?' + searchParams.toString()
    });
  }

  const handleCloseBenefitModal = () => {
    const today = new Date().toDateString();
    const now = Date.now();
    const benefitModalData = JSON.parse(localStorage.getItem('benefitModalData') || '{}');
    
    // 更新弹出次数和时间
    const newData = {
      date: today,
      count: (benefitModalData.count || 0) + 1,
      lastShown: now
    };
    
    localStorage.setItem('benefitModalData', JSON.stringify(newData));
    setShowBenefitModal(false);
  };

  // 设置访问源 与 到期时间 s source d detail t time
  useEffect(() => {
    if (source && detail) {
      const isSameDay = (date1, date2) => {
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
        );
      }

      const obj = window?.localStorage?.getItem('s_d_v');
      if (obj) {
        const array = obj?.split('_')
        if (Array.isArray(array) && array?.length === 3) {
          const oldSource = array[0];
          const oldDetail = array[1];
          const oldTime = parseInt(array[2]);
          const now = Date.now();
         
          if (oldSource !== source || oldDetail !== detail || !isSameDay(new Date(oldTime), new Date(now))) { 
            window?.localStorage?.setItem('s_d_v', `${source}_${detail}_${Date.now()}`);
            recordEventRecord({
              event_name: 'haohui_source_visit',
              source: source,
              event_id: detail,
            })
            // posthog?.capture('haohui_source_visit', {
            //   source: source,
            //   detail: detail,
            // });
          }

        }
      } else {
        window?.localStorage?.setItem('s_d_v', `${source}_${detail}_${Date.now()}`);
        // posthog?.capture('haohui_source_visit', {
        //   source: source,
        //   detail: detail,
        // });
        recordEventRecord({
          event_name: 'haohui_source_visit',
          source: source,
          event_id: detail,
        })
      }
    }
  }, [source, detail])

  useEffect(() => {
    // eventBus.on('alert-message-error' , (message) => {
    //   setAletObj({
    //     visible: true,
    //     message
    //   })
    // })
    // const timer = setTimeout(() => {
    //   document.querySelector('#video')?.play()
    // }, 100)
    // return () => {
    //   clearTimeout(timer)
    // }
    
    const checkBenefitModal = () => {
      // 检查是否已完成付款，如果是则不再显示弹框
      const paymentCompleted = localStorage.getItem('paymentCompleted');
      if (paymentCompleted === 'true') {
        return;
      }
      
      const today = new Date().toDateString();
      const now = Date.now();
      const benefitModalData = JSON.parse(localStorage.getItem('benefitModalData') || '{}');
      
      // 检查是否是新的一天
      if (benefitModalData.date !== today) {
        // 新的一天，重置计数
        localStorage.setItem('benefitModalData', JSON.stringify({
          date: today,
          count: 0,
          lastShown: 0
        }));
        setShowBenefitModal(true);
      } else {
        // 同一天，检查弹出次数和时间间隔
        const hoursSinceLastShown = (now - benefitModalData.lastShown) / (1000 * 60 * 60);
        if (benefitModalData.count < 3 && hoursSinceLastShown >= 2) {
          setShowBenefitModal(true);
        }
      }
    };
    checkBenefitModal();
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      const v = videoRef.current;
      if (v) {
        v.muted = true; // Safari 必须显式设置
        v.playsInline = true;
        v.loop = true;
        v.setAttribute("muted", "");       // 双保险
        v.setAttribute("playsinline", ""); // 双保险
        v.setAttribute("loop", ""); // 双保险
        v.play().catch(err => {
          console.log("Autoplay blocked:", err);
        });
      }
    })
    return () => {
      clearTimeout(timer)
    }
  }, []);

  return (
    <>
      {/* 新年福利弹窗 */}
      {activityConfig?.vip_new_year_promotion?.use_config && <Modal
        open={showBenefitModal}
        onCancel={handleCloseBenefitModal}
        footer={null}
        closable={false}
        centered
        className="benefit-modal"
        style={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          padding: 0,
          width: 'auto',
          maxWidth: '90vw'
        }}
      >
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <img
            onClick={handleJumpLink}
            src={ActivityImg}
            alt="福利图片"
            style={{
              display: 'block',
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          />
          <button
            onClick={handleCloseBenefitModal}
            style={{
              ...(isPc? {
                top: '0px',
                right: '-90px',
              } : {
                top: '-30px',
                right: '-10px',
              }),
              position: 'absolute',
              backgroundColor: 'transparent',
              color: 'white',
              border: 'none',
              padding: '4px 8px',
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            放弃福利 <span style={{ fontSize: '16px' }}>×</span>
          </button>
        </div>
      </Modal>}
      <div className="home" style={isPc ? { minWidth: '1310px', overflowX: 'auto' } : {}}>
        <Header {...props} />
        {/* {
          alertObj?.visible 
            ? (
              <Alert style={{ zIndex: 20, marginTop: '16px' }} message={alertObj?.message} type="error" showIcon closable />
            )
            : null
        } */}
        <div className={isPc ? 'homeBox' : 'mobile-homeBox'}>
          {/* <div className="logo">
            <img
              style={{
                width: "180px",
                height: "110px",
                marginLeft: "-25px",
                marginBottom: "-20px",
              }}
              alt="cemeta.png"
              src="/logo/cemeta.png"
            />

          </div> */}
          <div className="home-content" style={isPc ? { marginTop: '200px' } : { marginTop: '8em' }}>CeMeta</div>
          <div className="home-title">森宇宙好绘AI电商设计工具</div>
          <div className="home-content" style={isPc ? { marginTop: '16px', marginBottom: '120px' } : { marginBottom: '4em' }}>一人一天一套详情页</div>

          <div className="homeBox-footer-button">
            <Button
              style={{ marginRight: "32px" }}
              onClick={handleMACDownload}
            >
              <img
                style={{ width: "26px", height: "26px", marginRight: "4px" }}
                alt=""
                aria-hidden="true"
                src="/logo/svg/mac.svg"
              />
              mac 版本下载
            </Button>
            <Button
              style={{ marginRight: "32px" }}
              onClick={handleWINDownload}
            >
              <img
                style={{ width: "26px", height: "26px", marginRight: "4px" }}
                alt=""
                aria-hidden="true"
                src="/logo/svg/windows.svg"
              />
              win 版本下载
            </Button>
          </div>
          <a
            ref={macRef}
            href={mac_plugin_latest_url}
            style={{ visibility: "hidden" }}
          >
            {" "}
          </a>
          <a
            ref={winRef}
            href={win_plugin_latest_url}
            style={{ visibility: "hidden" }}
          >
            {" "}
          </a>
        </div>
        {
          !isPc
            ? null
            : <video ref={videoRef} id="video" className="video" style={{ height: '60%' }} autoPlay muted playsInline loop>
              <source src="https://shopping-cdn.cemeta.cn/common/homeVideo.mp4" type="video/mp4" />
            </video>
        }

        {/* 长图切片懒加载组件 */}
        <div className="scroll-image-container" style={isPc ? {} : { marginTop: '60vh' }}>
          <ScrollLazyLoadImage />
        </div>
      </div>
    </>
  );
};

export default Home;
